import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { authinstance } from "sagas";
import {
    FETCH_ALL_COUNTRY,
    UPDATE_COUNTRY,
    CREATE_COUNTRY,
    DELETE_COUNTRY,
    FETCH_ALL_CONTRY_LANG,
    UPDATE_CONTRY_LANG,
    CREATE_CONTRY_LANG, DELETE_CONTRY_LANG,
    FETCH_ALL_SPECIALITY,
    UPDATE_SPECIALITY,
    CREATE_SPECIALITY, DELETE_SPECIALITY,
    FETCH_ALL_CONTENT_TYPES,
    FETCH_ALL_HEALTH_PARTNER_TYPES,
    FETCH_ALL_ROLES,
    FETCH_ALL_FEATURE_TYPES,
    FETCH_ALL_LANG,
    UPDATE_LANG,
    CREATE_LANG, DELETE_LANG,
    FETCH_REPORT_CONFIG,
    DELETE_REPORT_CONFIG,
    CREATE_REPORT_CONFIG,
    UPDATE_REPORT_CONFIG,
    CREATE_DOCTOR_REPORTS,
    VIEW_DOCTOR_REPORTS
} from 'constants/master_data.constants'
import axios from 'axios'
import {
    fetchCountriesSuccess,
    updateCountrySuccess,
    createCountrySuccess,
    deleteCountrySuccess,
    fetchCountryLangsSuccess,
    updateCountryLangSuccess,
    createCountryLangSuccess,
    deleteCountryLangSuccess,
    fetchSpecialitiesSuccess,
    updateSpecialitySuccess,
    createSpecialitySuccess,
    deleteSpecialitySuccess,
    fetchContentTypesSuccess,
    fetchHealthPartnerTypesSuccess,
    fetchRolesSuccess,
    fetchFeatureTypesSuccess,
    fetchLangsSuccess,
    updateLangSuccess,
    createLangSuccess,
    deleteLangSuccess,
    fetchConfigSuccess,
    deleteConfigSuccess,
    createConfigSuccess,
    updateConfigSuccess,
    sendDoctorReportsSuccess,
    viewDoctorReportsSuccess
} from "actions/master_data.action";
import { showErrors, stopLoader, setNotification } from "actions/general.action";

const fetchCountriesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/countries');
}

function* fetchCountries({ payload }) {
    try {
        const reuslt = yield call(fetchCountriesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchCountriesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const fetchRolesRequest = async (page) => {
    return authinstance.get('api/v1/super_admin/roles/index?is_portal=1');
}

function* fetchRoles({ payload }) {
    try {
        const reuslt = yield call(fetchRolesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchRolesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const fetchFeatureTypesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/feature_types');
}


function* fetchFeatureTypes({ payload }) {
    try {
        const reuslt = yield call(fetchFeatureTypesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchFeatureTypesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const updateCountriesRequest = async (payload) => {
    return axios.put('/api/v1/super_admin/countries/' + payload.id,
        payload
    );
}

function* updateCounty({ payload }) {
    try {
        const reuslt = yield call(updateCountriesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateCountrySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const createCountriesRequest = async (payload) => {
    delete payload.id
    return axios.post('/api/v1/super_admin/countries',
        payload
    );
}

function* createCounty({ payload }) {
    try {
        const reuslt = yield call(createCountriesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(createCountrySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const deleteCountriesRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/countries/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteCountry({ payload }) {
    try {
        const reuslt = yield call(deleteCountriesRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteCountrySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

// country_lang sagas

const fetchCountryLangsRequest = async (page) => {
    return axios.get('/api/v1/super_admin/country_langs');
}

function* fetchCountryLangs({ payload }) {
    try {
        const reuslt = yield call(fetchCountryLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchCountryLangsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const updateCountryLangsRequest = async (payload) => {
    let s = Object.assign({}, payload);
    s["lang"] = { id: s.lang_id }
    s["country"] = { id: s.country_id }
    delete s.country_id
    delete s.lang_id

    return axios.put('/api/v1/super_admin/country_langs/' + payload.id,
        s
    );
}

function* updateCountryLang({ payload }) {
    try {
        const reuslt = yield call(updateCountryLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateCountryLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const createCountryLangsRequest = async (payload) => {
    delete payload.id
    let s = Object.assign({}, payload);
    s["country"] = { id: s.country_id }
    s["lang"] = { id: s.lang_id }
    delete s.country_id
    delete s.lang_id
    return axios.post('/api/v1/super_admin/country_langs',
        s
    );
}

function* createCountryLang({ payload }) {
    try {
        const reuslt = yield call(createCountryLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(createCountryLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const deleteCountryLangsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/country_langs/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteCountryLang({ payload }) {
    try {
        const reuslt = yield call(deleteCountryLangsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteCountryLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}


// specility 
const fetchLangsRequest = async (page) => {
    return axios.get('/api/v1/public/langs');
}

function* fetchLangs({ payload }) {
    try {
        const reuslt = yield call(fetchLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchLangsSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const updateLangsRequest = async (payload) => {
    let s = Object.assign({}, payload);
    delete s.country_id
    return axios.put('/api/v1/super_admin/langs/' + payload.id,
        s
    );
}

function* updateLang({ payload }) {
    try {
        const reuslt = yield call(updateLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const createLangsRequest = async (payload) => {
    delete payload.id
    let s = Object.assign({}, payload);
    delete s.country_id
    return axios.post('/api/v1/super_admin/langs',
        s
    );
}

function* createLang({ payload }) {
    try {
        const reuslt = yield call(createLangsRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(createLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const deleteLangsRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/langs/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteLang({ payload }) {
    try {
        const reuslt = yield call(deleteLangsRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteLangSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

// specility 
const fetchSpecialitiesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/specialities');
}

function* fetchSpecialities({ payload }) {
    try {
        const reuslt = yield call(fetchSpecialitiesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchSpecialitiesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const updateSpecialitiesRequest = async (payload) => {
    let s = Object.assign({}, payload);
    s["country"] = { id: s.country_id }
    delete s.country_id
    return axios.put('/api/v1/super_admin/specialities/' + payload.id,
        s
    );
}

function* updateSpeciality({ payload }) {
    try {
        const reuslt = yield call(updateSpecialitiesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateSpecialitySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const createSpecialitiesRequest = async (payload) => {
    delete payload.id
    let s = Object.assign({}, payload);
    s["country"] = { id: s.country_id }
    delete s.country_id
    return axios.post('/api/v1/super_admin/specialities',
        s
    );
}

function* createSpeciality({ payload }) {
    try {
        const reuslt = yield call(createSpecialitiesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(createSpecialitySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const deleteSpecialitiesRequest = async (id) => {
    return axios({
        method: "delete",
        url: '/api/v1/super_admin/specialities/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteSpeciality({ payload }) {
    try {
        const reuslt = yield call(deleteSpecialitiesRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteSpecialitySuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}


// country_lang contentTypes

const fetchContentTypesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/content_types');
}

function* fetchContentTypes({ payload }) {
    try {
        const reuslt = yield call(fetchContentTypesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchContentTypesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

//  partnerTypes

const fetchHealthPartnerTypesRequest = async (page) => {
    return axios.get('/api/v1/super_admin/health_partner_types');
}

function* fetchHealthPartnerTypes({ payload }) {
    try {
        const reuslt = yield call(fetchHealthPartnerTypesRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchHealthPartnerTypesSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}


// config
const fetchConfigRequest = async (page) => {
    return axios.get('/api/v1/super_admin/config');
}

function* fetchConfig({ payload }) {
    try {
        const reuslt = yield call(fetchConfigRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchConfigSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const updateReportConfigRequest = async (payload) => {
    let s = Object.assign({}, payload);
    return axios.put('/api/v1/super_admin/config',
        s
    );
}

function* updateReportConfig({ payload }) {
    try {
        const reuslt = yield call(updateReportConfigRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateConfigSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error));
    }
}

const createDoctorReportsRequest = async (payload) => {
    return axios.get('/api/v1/super_admin/doctors/email_doctor_invoice', {
        params: payload
    });
}

function* createDoctorReports({ payload }) {
    let notification = {
        open: true,
        status: "",
        message: "",
      }
    try {
        const reuslt = yield call(createDoctorReportsRequest, payload);
        if (reuslt.message) {
            notification.status = "error";
            notification.message = reuslt.message;
            yield put(stopLoader());
            yield put(setNotification(notification));
        } else {
            notification.status = reuslt.data.data.alert ? "warning" : "success";
            notification.message = reuslt.data.data.alert || "Doctor Reports Sent";
            yield put(sendDoctorReportsSuccess(reuslt.data));
            yield put(stopLoader());
            yield put(setNotification(notification));
        }
    } catch (error) {
        notification.status = "error";
        notification.message = error;
        yield put(stopLoader());
        yield put(setNotification(notification));
    }
}

const viewDoctorReportsRequest = async (payload) => {
    return axios.get('/api/v1/super_admin/doctors/email_doctor_invoice', {
        params: payload
    });
}

function* viewDoctorReports({ payload }) {
    let notification = {
        open: true,
        status: "",
        message: "",
      }
    try {
        const reuslt = yield call(viewDoctorReportsRequest, payload);
        if (reuslt.message) {
            notification.status = "error";
            notification.message = reuslt.message;
            yield put(stopLoader());
            yield put(setNotification(notification));
        } else {
            notification.status = reuslt.data.data.alert ? "warning" : "success";
            notification.message = reuslt.data.data.alert || "Data View Success";
            if(notification.message === "Data View Success") {
                notification.open = false;
                yield put(viewDoctorReportsSuccess(reuslt.data));
            }
            yield put(stopLoader());
            yield put(setNotification(notification));
        }
    } catch (error) {
        notification.status = "error";
        notification.message = error;
        yield put(stopLoader());
        yield put(setNotification(notification));
    }
}


//fork partner types

// fork contentTypes
export function* forkFetchHealthPartnerTypes() {
    yield takeEvery(FETCH_ALL_HEALTH_PARTNER_TYPES, fetchHealthPartnerTypes);
}

// fork LANG
export function* forkFetchLangs() {
    yield takeEvery(FETCH_ALL_LANG, fetchLangs);
}

export function* forkUpdateLang() {
    yield takeEvery(UPDATE_LANG, updateLang);
}

export function* forkCreateLang() {
    yield takeEvery(CREATE_LANG, createLang);
}

export function* forkDeleteLang() {
    yield takeEvery(DELETE_LANG, deleteLang);
}

// fork SPECIALITY
export function* forkFetchSpecialities() {
    yield takeEvery(FETCH_ALL_SPECIALITY, fetchSpecialities);
}

export function* forkUpdateSpeciality() {
    yield takeEvery(UPDATE_SPECIALITY, updateSpeciality);
}

export function* forkCreateSpeciality() {
    yield takeEvery(CREATE_SPECIALITY, createSpeciality);
}

export function* forkDeleteSpeciality() {
    yield takeEvery(DELETE_SPECIALITY, deleteSpeciality);
}

// fork country_lang
export function* forkFetchCountryLangs() {
    yield takeEvery(FETCH_ALL_CONTRY_LANG, fetchCountryLangs);
}

export function* forkUpdateCountryLang() {
    yield takeEvery(UPDATE_CONTRY_LANG, updateCountryLang);
}

export function* forkCreateCountryLang() {
    yield takeEvery(CREATE_CONTRY_LANG, createCountryLang);
}

export function* forkDeleteCountryLang() {
    yield takeEvery(DELETE_CONTRY_LANG, deleteCountryLang);
}

// fork country
export function* forkFetchCountries() {
    yield takeEvery(FETCH_ALL_COUNTRY, fetchCountries);
}

export function* forkUpdateCountry() {
    yield takeEvery(UPDATE_COUNTRY, updateCounty);
}

export function* forkCreateCountry() {
    yield takeEvery(CREATE_COUNTRY, createCounty);
}

export function* forkDeleteCountry() {
    yield takeEvery(DELETE_COUNTRY, deleteCountry);
}

// fork contentTypes
export function* forkFetchContentTypes() {
    yield takeEvery(FETCH_ALL_CONTENT_TYPES, fetchContentTypes);
}

// fork roles
export function* forkFetchRolesTypes() {
    yield takeEvery(FETCH_ALL_ROLES, fetchRoles);
}

//fork feature_types
export function* forkFetchFeatureTypes() {
    yield takeEvery(FETCH_ALL_FEATURE_TYPES, fetchFeatureTypes);
}

// fork config
export function* forkFetchConfig() {
    yield takeEvery(FETCH_REPORT_CONFIG, fetchConfig);
}

export function* forkUpdateReportConfig() {
    yield takeEvery(UPDATE_REPORT_CONFIG, updateReportConfig);
}

export function* forkCreateDoctorReports() {
    yield takeEvery(CREATE_DOCTOR_REPORTS, createDoctorReports);
}

export function* forkViewDoctorReports() {
    yield takeEvery(VIEW_DOCTOR_REPORTS, viewDoctorReports);
}

export default function* rootSaga() {
    yield all([
        fork(forkFetchCountries),
        fork(forkUpdateCountry),
        fork(forkCreateCountry),
        fork(forkDeleteCountry),
        fork(forkFetchCountryLangs),
        fork(forkUpdateCountryLang),
        fork(forkCreateCountryLang),
        fork(forkDeleteCountryLang),
        fork(forkFetchSpecialities),
        fork(forkUpdateSpeciality),
        fork(forkCreateSpeciality),
        fork(forkDeleteSpeciality),
        fork(forkFetchContentTypes),
        fork(forkFetchHealthPartnerTypes),
        fork(forkFetchRolesTypes),
        fork(forkFetchFeatureTypes),
        fork(forkFetchLangs),
        fork(forkUpdateLang),
        fork(forkCreateLang),
        fork(forkDeleteLang),
        fork(forkFetchConfig),
        fork(forkUpdateReportConfig),
        fork(forkCreateDoctorReports),
        fork(forkViewDoctorReports),
    ]);
}